const StatusBadge = ({ status }) => {
    const statusConfig = {
        OPEN: { bg: 'bg-emerald-500/10', text: 'text-emerald-600', dot: 'bg-emerald-500' },
        OCCUPIED: { bg: 'bg-blue-500/10', text: 'text-blue-600', dot: 'bg-blue-500' },
        MAINTENANCE: { bg: 'bg-amber-500/10', text: 'text-amber-600', dot: 'bg-amber-500' }
    };

    const config = statusConfig[status] || statusConfig.OPEN;

    return (
        <span className={`inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full ${config.bg} ${config.text}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
            {status}
        </span>
    );
};

export default StatusBadge;
